import { getDOMElement } from 'src/utils/DOM';

export const EMAIL_PATTERN =
  // eslint-disable-next-line max-len
  /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[\d{1,3}\.\d{1,3}\.\d{1,3}\.\d{1,3}])|(([a-zA-Z\-\d]+\.)+[a-zA-Z]{2,}))$/;

export const EMAIL_FORBIDDEN_CHARS =
  // eslint-disable-next-line max-len
  /^[^<>%$ ]*$/;

export const SELF_ORIGIN = `${window.location.origin}/`; // base url to the app

export const DEV_API_KEY = '/devApi';
// mustn't contain trailing '/'
export const API_URL = process.env.NODE_ENV === 'production' ? SELF_ORIGIN.slice(0, -1) : DEV_API_KEY;

export const CSS_ANIMATION_DURATION = 300; // ms

/** overrides the config key getting from api */
export const FROALA_KEY = 'jUA1yA4B3D1D1G2C2pZGCTRSAPJWTLPLZHTQQb1JGZxE2F2G2F1B10B2C2E6C1G1==';

export const DEFAULT_TABLE_PAGE_SIZE = 15;

export const INT_32_MAX_VALUE = 2 ** 31 - 1; //  2147483647

/** be careful choosing a DOM element (body isn't allowed) */
export const DOM_ELEMENT_FOR_PORTALS: Element = getDOMElement('#root') as Element;

export const COUNTRIES_HAVING_REGIONS = ['US', 'CA'];

export const GOOGLE_FONTS_LINK = 'https://fonts.google.com/';

export const FULL_DATE_FORMAT = 'yyyy/MM/dd HH:mm:ss';

export const DATE_FORMAT_TIMEZONE = "yyyy-MM-dd'T'HH:mm:ss.SSS'Z'";
export const DATE_FORMAT_TIMEZONE_SHORT = "yyyy-MM-dd'T'HH:mm:ss'Z'";

export const TABLET_WIDTH = 1024;

export const TYPEAHEAD_THRESHOLD = 50;
